import React from "react";

// Cartão usado na vista mobile (abaixo de 768px) para representar cada linha
// de uma tabela, em qualquer painel da app.
export default function CardMobile({
  titulo,
  badge,
  acoes,
  urgente,
  alertaGap,
  areaComum,
  resumo,
  detalhes,
  footer,
}) {
  // Mesma prioridade que a tabela de desktop: Área Comum (verde) sobrepõe-se
  // ao alerta de intervalo longo (azul), que por sua vez sobrepõe-se ao
  // urgente (rosa), quando mais do que um se aplica.
  const classeEstado = areaComum
    ? " area-comum"
    : alertaGap
    ? " alerta-gap"
    : urgente
    ? " urgente"
    : "";
  return (
    <div className={`card-limpeza${classeEstado}`}>
      <div className="card-limpeza__cabecalho">
        <div className="card-limpeza__titulo">{titulo}</div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {badge}
          {acoes && <div className="card-limpeza__acoes">{acoes}</div>}
        </div>
      </div>

      {resumo && resumo.length > 0 && (
        <div className="card-limpeza__resumo">
          {resumo.map((linha, i) => (
            <div className="card-limpeza__linha" key={i}>
              <span className="card-limpeza__linha-label">{linha.label}</span>
              <span className="card-limpeza__linha-valor">{linha.valor}</span>
            </div>
          ))}
        </div>
      )}

      {detalhes && detalhes.length > 0 && (
        <details className="card-limpeza__detalhes">
          <summary>Ver mais</summary>
          <div className="card-limpeza__detalhes-corpo">
            {detalhes.map((linha, i) =>
              linha.full ? (
                <div key={i}>{linha.valor}</div>
              ) : (
                <div className="card-limpeza__linha" key={i}>
                  <span className="card-limpeza__linha-label">
                    {linha.label}
                  </span>
                  <span className="card-limpeza__linha-valor">
                    {linha.valor}
                  </span>
                </div>
              )
            )}
          </div>
        </details>
      )}

      {footer && <div className="card-limpeza__footer">{footer}</div>}
    </div>
  );
}
